export default {
  methods: {
    /*
        Check for NULL and return message
        */
    isEmptyMessage(dataValue, errorMessage) {
      if (dataValue == null || dataValue.length === 0) {
        if (typeof errorMessage === 'undefined') {
          return '-';
        }
        return errorMessage;
      }
      return dataValue;
    },

    /*
        Check for NULL and return message
        */
    isEmptyCurrencyValue(dataValue, currencySymbol) {
      if (
        dataValue == null ||
        dataValue === 0 ||
        dataValue === 0.0 ||
        dataValue.length === 0 ||
        parseInt(dataValue, 10) === 0
      ) {
        return '-';
      }
      return this.formatCurrency(dataValue, currencySymbol);
    },

    /*
        Set YYYY-MM-DD to DD/MM/YYYY
        */
    formatDate(dateString) {
      // eslint-disable-next-line no-console
      // console.error('Please call DateTools::formatDate() in the future. ToolsMixin::formatDate '
      //   + 'function is being deprecated.');
      if (typeof dateString === 'undefined' || !dateString) {
        return '';
      }
      const theDay = dateString.substring(8, 10);
      const theMonth = dateString.substring(5, 7);
      const theYear = dateString.substring(0, 4);
      return `${theDay}/${theMonth}/${theYear}`;
    },

    /*
        Set Flag from ISO "ALPHA-2 Code Country Code
        */
    getFlag(countryCode) {
      return `flag-icon flag-icon-${countryCode.toLowerCase()}`;
    },

    /*
        Format number with commas
        */
    delimitNumbers(str) {
      return `${str}`.replace(
        /\b(\d+)((\.\d+)*)\b/g,
        (a, b, c) =>
          (b.charAt(0) > 0 && !(c || '.').lastIndexOf('.')
            ? b.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
            : b) + c
      );
    },

    /*
        Format number and add currency
        */
    formatCurrency(value, theCurrency) {
      let lCurrency = theCurrency;
      if (typeof theCurrency === 'undefined') lCurrency = '';
      const flooredNumber = Math.floor(value);
      const delimitedNumber = this.delimitNumbers(flooredNumber);
      return `${lCurrency} ${delimitedNumber}`;
    },

    /*
        Format Percentage
        */
    formatPercentage(value) {
      if (value == null || value === 0 || parseFloat(value, 10) === 0.0) {
        return '-';
      }
      return `${value}%`;
    },

    /**
     * Checks to make sure the percentage chaneg we have makes sense or isn't null and provides a
     * boolean that is used to decide if we should show it or not in the front end.
     * This came out of a couple of requirements
     * 1) don't show null labels and
     * 2) DueDil sent us some crazy percentages on April 16th and this will stop these being shown
     *    in front end
     */
    validPercentageChange(value) {
      if (
        value != null &&
        value < 100000 &&
        value > -100000 &&
        value !== 0 &&
        (parseInt(value, 10) !== 0 || parseFloat(value, 10) !== 0.0)
      ) {
        return true;
      }
      return false;
    },

    /*
        formatAge
        */
    formatAge(value, thePeriod) {
      const flooredNumber = Math.floor(value);
      if (typeof thePeriod === 'undefined') {
        return `${flooredNumber} `;
      }
      return `${flooredNumber} ${thePeriod}`;
    },

    zeroFill(number, width) {
      let s = `${number}`;
      while (s.length < width) s = `0${s}`;
      return s;
    },

    /*
        format Date of Birth provided as M YYYY to MM/YYYY
        */
    formatDOB(monthValue, yearValue) {
      let formattedDate = '';
      if (!monthValue || !yearValue) {
        formattedDate = '';
      } else {
        const formattedMonth = this.zeroFill(monthValue, 2);
        formattedDate = `${formattedMonth}/${yearValue}`;
      }
      return formattedDate;
    },

    /*
        Set label based on  simple status
        */
    setLabeltoStatus(string) {
      let theLabelStyle = 'label label-';
      if (
        string === 'Closed' ||
        string === 'Dissolved' ||
        string === 'Converted / Closed' ||
        string === 'NonActive' ||
        string === 'Non Active'
      ) {
        theLabelStyle += 'negative';
      } else if (string.match(/Active/)) {
        theLabelStyle += 'positive';
      } else if (string === 'Liquidation') {
        theLabelStyle += 'liquidated';
      } else {
        theLabelStyle += 'neutral';
      }
      return theLabelStyle;
    },

    /**
     * Set DeltaChange direction 1 = positive, 0 = neutral, -1 = negative
     *
     * @param DeltaChange
     * @returns {string}
     */
    getDeltaChangeDirection(DeltaChange) {
      const lDeltaChange = Number(DeltaChange);
      if (lDeltaChange > 0) {
        return '1';
      }
      if (lDeltaChange < 0) {
        return '-1';
      }
      return '0';
    },

    /**
     * Set bootstrap label style based on delta change.
     *
     * @param value
     * @returns {string}
     */
    getLabelStyle(value, direction, isCreditSafeReport) {
      let theLabelStyle = 'label label-';
      let theDirection = 0;
      if (isCreditSafeReport) {
        theDirection = direction.toString();
      } else {
        theDirection = this.getDeltaChangeDirection(value);
      }
      if (theDirection === '1') {
        theLabelStyle += 'positive';
      } else if (theDirection === '-1') {
        theLabelStyle += 'negative';
      } else {
        theLabelStyle += 'neutral';
      }
      return theLabelStyle;
    },

    /*
        Set chevron indicator based on delta change
        */
    getGlyphicon(value, direction, isCreditSafeReport) {
      let theGlyphicon = 'glyphicon glyphicon-';
      let theDirection = 0;
      if (isCreditSafeReport) {
        theDirection = direction.toString();
      } else {
        theDirection = this.getDeltaChangeDirection(value);
      }
      if (theDirection === '1') {
        theGlyphicon += 'chevron-up';
      } else if (theDirection === '-1') {
        theGlyphicon += 'chevron-down';
      } else {
        theGlyphicon += 'minus';
      }
      return theGlyphicon;
    },

    /*
        get webpresence icon
        */
    getWebIcon(presencetype) {
      if (
        presencetype === 'twitter' ||
        presencetype === 'facebook' ||
        presencetype === 'linkedin'
      ) {
        return `fab fa-${presencetype}`;
      }
      return 'fas fa-link';
    },
    /**
     * Run Report URL Builder
     */
    runReportURL(companyId) {
      const theURL = 'https://api.endcustomer.co.uk/v1/reports/';
      return theURL + companyId;
    },
    /**
     * Convert 1 (string or int) to 'Y' and everything else to 'N'
     */
    convertYN(string) {
      if (parseInt(string, 10) === 1) {
        return 'Y';
      }
      return 'N';
    },
    getUnderwritingComment(theCategory, theColour) {
      const lCategory = theCategory.toLowerCase();
      const lColour = theColour.toLowerCase();
      let description = '-';

      /* Theft */
      if (lCategory === 'theft') {
        if (lColour === 'green') {
          description =
            'Generally standard rating/protection levels required (minimum security) or alarm signalling depending on sums insured.';
        } else if (lColour === 'amber') {
          description =
            'Typically the immediate area triggers the need for (approved) alarm signalling protection (varies by trade & type of goods). Check with Underwriter.';
        } else if (lColour === 'red') {
          description =
            'Probable (approved) alarm signalling required or cover to be provided. Check with Underwriter.';
        } else if (lColour === 'black') {
          description =
            'A survey will probably be required for cover to be considered. Check with Underwriter.';
        }
      }

      /* Subsidence */
      if (lCategory === 'subsidence') {
        if (lColour === 'green') {
          description = 'Generally standard rating/excess if optional cover required.';
        } else if (lColour === 'amber') {
          description = 'Typically an increased subsidence excess/additional rating applies.';
        } else if (lColour === 'red') {
          description =
            'A subsidence questionnaire will probably be required for cover to be considered. Check with Underwriter.';
        } else if (lColour === 'black') {
          description =
            'Significant risk of subsidence. Check with Underwriter for cover requirements.';
        }
      }

      /* flood */
      if (lCategory === 'flood') {
        if (lColour === 'green') {
          description = 'Lower risk of flooding in the immediate area.';
        } else if (lColour === 'amber') {
          description =
            'Risk of flooding in immediate area is present, but generally at low depth level (30cm to 1m) or low frequency.';
        } else if (lColour === 'red') {
          description =
            'Increased risk of flooding in immediate area is present at higher depth (1m+) or more frequent low depth flooding.';
        } else if (lColour === 'black') {
          description =
            'Significant risk of flooding at extreme depth or frequency. Check with Underwriter for cover requirements.';
        }
      }

      return description;
    },

    /**
     * Convert seconds to hh-mm-ss format.
     * @param {number} totalSeconds - the total seconds to convert to hh-mm-ss
     * */
    SecondsTohhmmss(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
      let seconds = totalSeconds - hours * 3600 - minutes * 60;

      // round seconds
      seconds = Math.round(seconds * 100) / 100;

      let result = hours < 10 ? `0${hours}` : hours;
      result += `:${minutes < 10 ? `0${minutes}` : minutes}`;
      result += `:${seconds < 10 ? `0${seconds}` : seconds}`;
      return result;
    },
  },
};
